/// <amd-module name="Dashboards/DashboardTemplates/DashboardTemplateCard" />
import * as React from "react";

import * as Resources from "Dashboards/DashboardTemplates/Resources";

import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { Image } from "VSSUI/Image";

export interface DashboardTemplateCardProps {
    templateID: string;
    templateTitle: string;
    templateSubtitle: string;
    templateThumbnail: string;
    onDashboardTemplateCardClick: () => void;
}

export class DashboardTemplateCard extends VssComponent<DashboardTemplateCardProps> {
    public render(): JSX.Element {
        return (
            <div className="dashboard-template-card" onClick={this.props.onDashboardTemplateCardClick}>
                <Card className="dashboard-template-card-img">
                    <Image
                        containImage={true}
                        src={this.props.templateThumbnail}
                        alt={format(Resources.DashboardTemplatePage_ThumbnailText, this.props.templateTitle)}
                    />
                </Card>
                <div className="dashboard-template-card-title">{this.props.templateTitle}</div>
                <div className="dashboard-template-card-description">{this.props.templateSubtitle}</div>
            </div>
        );
    }
}
